import type { ICustomControlData } from './RustEcgAddEdit';
import { FormDivider, FormParagraph, HeaderDivider } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';
import { CardioTypes } from './cardioTypes';
import { KlachtenRead } from './Klachten';
import { LichamelijkOnderzoekRead } from './LichamelijkOnderzoek';
import { RedenenRead } from './Redenen';
import { RisicofactorenRead } from './Risicofactoren';
import { VoorgeschiedenisRead } from './Voorgeschiedenis';

interface IRustEcgReadProps {
    cardioType: CardioTypes;
    customControlData: ICustomControlData;
}

export function RustEcgRead(props: IRustEcgReadProps) {
    const showAnamnese = showMoreRustEcg(props.cardioType, props.customControlData);

    return (
        <>
            {showAnamnese && <HeaderDivider text="Anamnese" />}

            {(props.customControlData.klacht || props.customControlData.klachten) && (
                <KlachtenRead customControlData={props.customControlData} />
            )}

            {props.cardioType === CardioTypes.restEcgRequest &&
                (props.customControlData.reden || props.customControlData.redenen) && (
                    <RedenenRead customControlData={props.customControlData} />
                )}

            {props.customControlData.lab && (
                <HorizontalFormGroupRead>
                    <FormLabel>Lab</FormLabel>
                    <InputContainer>
                        <FormParagraph>{props.customControlData.lab}</FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}

            {props.customControlData.voorgeschiedenis && (
                <VoorgeschiedenisRead {...props.customControlData.voorgeschiedenis} />
            )}

            {props.customControlData.risicofactoren && (
                <RisicofactorenRead {...props.customControlData.risicofactoren} />
            )}

            {props.customControlData.lichamelijkOnderzoek && (
                <LichamelijkOnderzoekRead {...props.customControlData.lichamelijkOnderzoek} />
            )}

            {showAnamnese && <FormDivider />}
        </>
    );
}

export function showMoreRustEcg(cardioType: CardioTypes, customControlData: ICustomControlData) {
    return Boolean(
        customControlData.klacht ||
            customControlData.klachten ||
            (cardioType === CardioTypes.restEcgRequest && (customControlData.reden || customControlData.redenen)) ||
            customControlData.lab ||
            customControlData.voorgeschiedenis ||
            customControlData.risicofactoren ||
            customControlData.lichamelijkOnderzoek
    );
}
